export {default as Input} from './Input'



// WEBPACK FOOTER //
// ./src/components/inputs/Input/index.js